import { render, staticRenderFns } from "./MapTab.vue?vue&type=template&id=36a16dae&"
import script from "./MapTab.vue?vue&type=script&lang=js&"
export * from "./MapTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports